<template>
  <el-dialog
    title="审批记录"
    width="766px"
    :center="true"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <data-table
      ref="dataTable"
      class="sms_table w-full h-full overflow-hidden"
      cell-class-name="truncate-table-cell-wrap"
      align="left"
      height="60vh"
      :data="tableData"
      :loading="tableLoading"
      :columns="columns"
      :show-page="false"
      :page="page"
      :show-tooltip="true"
      @size-change="changeSize"
      @pagination-current-change="changeNum">
        <template #auditStatus="{row}">
          <span class="rounded-full inline-block w-2 h-2 mr-2" :class="getAuditClass(row.auditStatus)"></span>
          <span>{{ getAuditStatus(row.auditStatus) }}</span>
        </template>
    </data-table>
  </el-dialog>
</template>

<script>
import DataTable from '@/components/base/DataTable'
import { auditListQy, auditListQyMsg } from '@/api/cost-settlement/approve'
import { soTypeCode } from '../config/cost-sett'

export default {
  components: { DataTable, },
  props: {
    visibility: {
      type: Boolean,
      default: false
    },
    id: {
      type: String | Number,
      default: ''
    }
  },
  watch: {
    visible(v) {
      // this.visible = v
      if(v) this.getList()
    }
  },
  mounted() {
    this.visible = this.visibility
    this.getList()
  },
  data() {
    return {
      tableData: [],
      tableLoading: false,
      columns: [
        { label: '日期', value: 'createTime', width: '250px'},
        { label: '操作人', value: 'auditorName', width: '100px'},
        { label: '操作类型', value: 'auditStatus', width: '120px'},
        { label: '审批备注', value: 'comment', width: '200px'},
      ],
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 2
      },
      // visible: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.visibility
      },
      set(v) {
        this.$emit('update:visibility', v)
      }
    },
    soType() {
      const type = this.$route.query.approveType ?? ''
      return type === '' ? '' : +type
    },
    isRedPocketAudit() {
      return this.soType && this.soType === soTypeCode.PACKET
    },
    isMessageAudit() {
      return this.soType && this.soType === soTypeCode.MESSAGE
    },
    listApi() {
      if(this.isRedPocketAudit) {
        return auditListQy
      }else {
        return auditListQyMsg
      }
    }
  },
  methods: {
    getAuditStatus(status){
      let str='-'
      switch (status) {
        case 0:
          str = '草稿'
          break
        case 1:
         str = '待审批'
          break
        case 2:
         str = '审批通过'
          break
        case 3:
         str = '审批驳回'
          break
      }
      return str
    },
    getAuditClass(status) {
      switch (status) {
        case 0:
        case 1:
         return 'bg-gray-300'
        case 2:
          return 'bg-green-500'
        case 3:
         return  'bg-red'
      }
    },
    changeSize(size) {
      this.page.currentPage = 1
      this.page.pageSize = size
    },
    changeNum(num) {
      this.page.currentPage = num
    },
    getList(){
      this.listApi(this.id).then(res => {
        this.tableData = res.data.data || []
      })
    }
  }
}
</script>

<style>

</style>